const $ = window.jQuery

class Minicart {
	constructor() {
		this.cartIcon = document.querySelector('.cart-icon')
		this.miniCartWrapper = document.querySelector('.widget_shopping_cart_content')
		this.miniCart = document.getElementById('sliding-mini-cart')
		this.headerElement = document.querySelector('.header')
		this.closeBtn = document.querySelector('.close-mini-cart')
		this.continueShopping = document.querySelector('.continue-shopping')
		this.events()
	}

	events() {
		// Update mini-cart on WC events.
		$(document.body).on('added_to_cart removed_from_cart', (res, fragments) => {
			const fragment = $(fragments['div.widget_shopping_cart_content'])

			$('#sliding-mini-cart').html(fragment[0])

			// Add event listener to close mini-cart
			$(document.body).on('click', '.close-mini-cart', () => {
				this.closeMiniCart()
			})

			$(document.body).on('click', '.continue-shopping', () => {
				this.closeMiniCart()
			})

			setTimeout(() => {
				this.updateProgressBars()
			}, 300)
		})

		if (!document.body.classList.contains('woocommerce-cart')) {
			// Add event listener to close mini-cart
			document.addEventListener('click', this.handleDocumentClickOutside.bind(this))

			// Add event listener to the cart icon
			if (this.cartIcon) {
				this.cartIcon.addEventListener('click', e => this.openMinicart(e))
			}

			// Add event listener to the close button
			if (this.closeBtn) {
				this.closeBtn.addEventListener('click', () => this.closeMiniCart())
			}

			// Add event listener to the continue shopping button
			if (this.continueShopping) {
				this.continueShopping.addEventListener('click', () => this.closeMiniCart())
			}

			// Add event listener to the quantity update buttons
			document.body.addEventListener(
				'click', (event) => {
					if (event.target.classList.contains('drl-item-quantity-btn')) {
						event.preventDefault()
						this.drlQuantityUpdateButtons(event.target)
					}
				}
			)

			// Add event listerner for WooCommerce events
			$(document.body).on('added_to_cart removed_from_cart wc_fragments_refreshed', () => {
				// Update progress bars
				const progressbars = $('.progress-bar-wrapper__bar')
				progressbars.each(function () {
					$(this).css('width', $(this).attr('data-width') + '%')
				})

				// Add event listener to close button
				this.closeBtn = $('.close-mini-cart')

				if (this.closeBtn.length > 0) {
					this.closeBtn.on('click', () => {
						this.closeMiniCart()
					})
				}

				// Add event listener to continue shopping button
				this.continueShopping = $('.continue-shopping')

				if (this.continueShopping.length > 0) {
					this.continueShopping.on('click', () => {
						this.closeMiniCart()
					})
				}

				this.updateCartIcon()
			})
		}
	}

	updateCartIcon() {
		const cartCountElement = $('#cart_count')

		if (!cartCountElement.length) {
			return
		}

		const amount = this.get_cookie('woocommerce_amount_in_cart')

		cartCountElement.text(amount)

		if (parseInt(amount) > 0) {
			cartCountElement.css('visibility', 'visible')
		} else {
			cartCountElement.css('visibility', 'hidden')
		}
	}

	get_cookie(name) {
		const nameEQ = name + '='
		const ca = document.cookie.split(';')
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i]
			while (c.charAt(0) === ' ') c = c.substring(1, c.length)
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
		}
		return null
	}

	openMinicart(e) {
		// Check if the body contains the class 'woocommerce-cart'
		if (document.body.classList.contains('woocommerce-cart')) {
			return
		}

		// Open panel
		this.miniCart.classList.add('open')
		document.body.classList.add('minicart-open')

		// Add event listener to close mini-cart
		this.closeMiniCartIcon = document.querySelector('.close-mini-cart')

		this.closeMiniCartIcon.addEventListener('click', () => {
			this.closeMiniCart()
		})

		// Add event listener to continue shopping button
		this.continueShopping = document.querySelector('.continue-shopping')

		this.continueShopping.addEventListener('click', () => {
			this.closeMiniCart()
		})

		// Update progress bars
		this.updateProgressBars()
	}

	handleDocumentClickOutside(e) {
		if (this.miniCart === null) {
			return
		}

		if (this.miniCart.classList.contains('open') && !this.miniCart.contains(e.target) && !this.cartIcon.contains(e.target)) {
			this.closeMiniCart()
		}
	}

	closeMiniCart() {
		// Close panel
		this.miniCart.classList.remove('open')
		document.body.classList.remove('minicart-open')

		// Reset progress bars
		const progressbars = document.querySelectorAll('.progress-bar-wrapper__bar')

		progressbars.forEach(bar => {
			const dataWidth = bar.getAttribute('data-width')
			if (dataWidth !== '100') {
				bar.style.width = '0%'
			}
		})
	}

	drlQuantityUpdateButtons(element) {
		// Prevent multiple clicks
		let drlQuantityUpdateSend = true

		if (drlQuantityUpdateSend) {
			// Prevent multiple clicks
			drlQuantityUpdateSend = false

			const wrap = $(element.closest('.woocommerce-mini-cart-item'))
			const input = wrap.find('.qty')
			const key = wrap.data('key')
			const type = element.getAttribute('data-type')
			let number = parseInt(input.val())
			let direction = type === 'minus' ? 'down' : 'up'

			// Update quantity
			if (type === 'minus') {
				number--
			} else {
				number++
			}

			if (number < 1) {
				number = 1
			}

			input.val(number)

			const data = {
				action: 'mini_cart_qty_update',
				key: key,
				number: number,
				security: js_data.mini_cart.nonce
			}
			
			// Add loading class
			const cartItem = $('[data-key="' + key + '"]')
			cartItem.addClass('loading')
			
			$.post(js_data.ajax_url, data)
			.done(res => {
				
				// Update other mini-cart elements
				$('#sliding-mini-cart .mini-cart-shipping').html(res['data']['shipping']);
				$('#sliding-mini-cart .mini-cart-total').html(res['data']['total_html']);
				$('#sliding-mini-cart .mini-cart-loyalty').html(res['data']['loyalty_points']);
				cartItem.find('.img-quantity').html(res['data']['item_quantity']);
				cartItem.removeClass('loading');
				drlQuantityUpdateSend = true;
			
				this.updateProgressBars(res['data']);
				this.updateCartIcon();

				const discountPercentage = res['data']['current_discount_percentage'];

				if ($('.coupon-row').length && res['data']['coupon'] !== '') {
					$('.coupon-row').html('<strong>' + res['data']['translations']['discount'] + ':</strong><span class="mini-cart-coupon">-' + res['data']['coupon'] + '</span>');
				} else if ($('.coupon-row').length) {
					$('.coupon-row').remove();
				} else if (res['data']['coupon'] !== '') {
					$('.total-row').after('<li class="coupon-row"><strong>' + res['data']['translations']['discount'] + ':</strong><span class="mini-cart-coupon">-' + res['data']['coupon'] + '</span></li>');
				}

				// Update discount percentage
				$('.woocommerce-mini-cart-item').each(function () {
					if ($(this).data('key') === key) {
						const priceWrapper = $(this).find('.price-wrapper').html(res['data']['product_price']);
						const discountMessageWrapper = $(this).find('.discount-message-wrapper');
				
						// If the .discount-message exists, update its content
						if (discountMessageWrapper.length) {
							discountMessageWrapper.html(res['data']['yith_discount_message']);
						} else {
							// If .discount-message does not exist, create it inside the wrapper
							$(this).find('.discount-message-wrapper').html(res['data']['yith_discount_message']);
						}
					}
				});
			})
			.fail((xhr, status, error) => {
				console.error('Error occurred during AJAX request:', error);
			});
			
		}
	}

	updateProgressBars(data) {
		const progressbars = document.querySelectorAll('.progress-bar-wrapper__bar')
		const progressbarPoints = document.querySelectorAll('.progress-bar-wrapper__point')
		let oldValues = []
		let newValues = []

		// Get the old values
		progressbars.forEach(bar => {
			oldValues.push(parseInt(bar.getAttribute('data-width')))
		})

		if (data !== undefined) {
			const updatedValues = data.progressbar.bars
			const updatedTargetPriceHTML = data.progressbar.spend_html
			const updatedTargetText = data.progressbar.text
			const targetPrice = document.getElementById('target-price')
			const targetText = document.getElementById('target-text')

			// Determine the direction of change
			const direction = updatedValues.map((value, index) => {
				return value.progressbar_percentage - oldValues[index] > 0 ? 1 : -1
			})

			// Get the highest price among the progress bars
			const highestPrice = Math.max(...data.progressbar.bars.map(bar => bar.price))

			// Check if the total is higher than the highest progress bar price
			if (data.total > highestPrice) {
				document.querySelector('.under').style.display = 'none'
				document.querySelector('.over').style.display = 'block'
			} else {
				document.querySelector('.under').style.display = 'block'
				document.querySelector('.over').style.display = 'none'
				targetPrice.innerHTML = updatedTargetPriceHTML
				targetText.innerHTML = updatedTargetText
			}

			// Update the progress bars
			progressbars.forEach((bar, index) => {
				const newValue = updatedValues[index].progressbar_percentage
				bar.style.width = newValue + '%'
				bar.setAttribute('data-width', newValue)
				newValues.push(newValue)
			})

			let counter = 0
			progressbarPoints.forEach((point, index) => {
				point.classList.remove('active-point')

				const newValue = updatedValues[index].progressbar_percentage
				if (newValue !== 100 && newValue !== 0) {
					point.classList.add('active-point')
				}

				if (newValue === 100 && counter === progressbarPoints.length - 1) {
					point.classList.add('active-point')
				}

				counter++
			})
		} else {
			// Reset the progress bars
			progressbars.forEach(bar => {
				bar.style.width = bar.getAttribute('data-width') + '%'
				bar.style.transition = ''
			})
		}
	}
}

window.addEventListener('DOMContentLoaded', new Minicart())